var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as moment from "moment";
import { addCommas } from "./numberMethods";
export var ESortOrder;
(function (ESortOrder) {
    ESortOrder[ESortOrder["ASC"] = 1] = "ASC";
    ESortOrder[ESortOrder["DESC"] = -1] = "DESC";
    ESortOrder[ESortOrder["UNCHANGED"] = 0] = "UNCHANGED";
})(ESortOrder || (ESortOrder = {}));
export var ratingWeightage = {
    AAAPLUSPOSITIVE: 1,
    AAAPLUSSTABLE: 2,
    AAAPLUS: 3,
    AAAPLUSNEGATIVE: 4,
    AAAPOSITIVE: 5,
    AAASTABLE: 6,
    AAA: 7,
    AAANEGATIVE: 8,
    AAAMINUSPOSITIVE: 9,
    AAAMINUSSTABLE: 10,
    AAAMINUS: 11,
    AAAMINUSNEGATIVE: 12,
    AAPLUSPOSITIVE: 13,
    AAPLUSSTABLE: 14,
    AAPLUS: 15,
    AAPLUSNEGATIVE: 16,
    AASTABLEPOSITIVE: 17,
    AASTABLE: 18,
    AA: 19,
    AANEGATIVE: 20,
    AAMINUSPOSITIVE: 21,
    AAMINUSSTABLE: 22,
    AAMINUS: 23,
    AAMINUSNEGATIVE: 24,
    APLUSPOSITIVE: 25,
    APLUSSTABLE: 26,
    APLUS: 27,
    APLUSNEGATIVE: 28,
    ASTABLEPOSITIVE: 29,
    ASTABLE: 30,
    A: 31,
    ANEGATIVE: 32,
    AMINUSPOSITIVE: 33,
    AMINUSSTABLE: 34,
    AMINUS: 35,
    AMINUSNEGATIVE: 36,
    BBBPLUSPOSITIVE: 37,
    BBBPLUSSTABLE: 38,
    BBBPLUS: 39,
    BBBPLUSNEGATIVE: 40,
    BBBPOSITIVE: 41,
    BBBSTABLE: 42,
    BBB: 43,
    BBBNEGATIVE: 44,
    BBBMINUSPOSITIVE: 45,
    BBBMINUSSTABLE: 46,
    BBBMINUS: 47,
    BBBMINUSNEGATIVE: 48,
    BBPLUSPOSITIVE: 49,
    BBPLUSSTABLE: 50,
    BBPLUS: 51,
    BBPLUSNEGATIVE: 52,
    BBPOSITIVE: 53,
    BBSTABLE: 54,
    BB: 55,
    BBNEGATIVE: 56,
    BBMINUSPOSITIVE: 57,
    BBMINUSSTABLE: 58,
    BBMINUS: 59,
    BBMINUSNEGATIVE: 60,
    BPLUSSTABLE: 61,
    BPLUS: 62,
    BPLUSNEGATIVE: 63,
    BSTABLE: 64,
    B: 65,
    BNEGATIVE: 66,
    BMINUSPOSITIVE: 67,
    BMINUSSTABLE: 68,
    BMINUS: 69,
    BMINUSNEGATIVE: 70,
    CCCPLUSPOSITIVE: 71,
    CCCPLUSSTABLE: 72,
    CCCPLUS: 73,
    CCCPLUSNEGATIVE: 74,
    CCCPOSITIVE: 75,
    CCCSTABLE: 76,
    CCC: 77,
    CCCNEGATIVE: 78,
    CCCMINUSPOSITIVE: 79,
    CCCMINUSSTABLE: 80,
    CCCMINUS: 81,
    CCCMINUSNEGATIVE: 82,
    CCPLUSPOSITIVE: 83,
    CCPLUSSTABLE: 84,
    CCPLUS: 85,
    CCPLUSNEGATIVE: 86,
    CCPOSITIVE: 87,
    CCSTABLE: 88,
    CC: 89,
    CCNEGAIVE: 90,
    CCMINUSPOSITIVE: 91,
    CCMINUSSTABLE: 92,
    CCMINUS: 93,
    CCMINUSNEGATIVE: 94,
    CPLUSPOSITIVE: 95,
    CPLUSSTABLE: 96,
    CPLUS: 97,
    CPLUSNEGATIVE: 98,
    CPOSITIVE: 99,
    CSTABLE: 100,
    C: 101,
    CNEGATIVE: 102,
    CMINUSPOSITIVE: 103,
    CMINUSSTABLE: 104,
    CMINUS: 105,
    CMINUSNEGATIVE: 106,
    DDDPLUSPOSITIVE: 107,
    DDDPLUSSTABLE: 108,
    DDDPLUS: 109,
    DDDPLUSNEGATIVE: 110,
    DDDPOSITIVE: 111,
    DDDSTABLE: 112,
    DDD: 113,
    DDDNEGATIVE: 114,
    DDDMINUSPOSITIVE: 115,
    DDDMINUSSTABLE: 116,
    DDDMINUS: 117,
    DDDMINUSNEGATIVE: 118,
    DDPLUSPOSIIVE: 119,
    DDPLUSSTABLE: 120,
    DDPLUS: 121,
    DDPLUSNEGATIVE: 122,
    DDPOSITIVE: 123,
    DDSTABLE: 124,
    DD: 125,
    DDNEGATIVE: 126,
    DDMINUSPOSITIVE: 127,
    DDMINUSSTABLE: 128,
    DDMINUS: 129,
    DDMINUSNEGATIVE: 130,
    DPLUSPOSITIVE: 131,
    DPLUSSTABLE: 132,
    DPLUS: 133,
    PLUSNEGATIVE: 134,
    DPOSITIVE: 135,
    DSTABLE: 136,
    D: 137,
    DNEGATIVE: 138,
    DMINUSPOSITIVE: 139,
    DMINUSSTABLE: 140,
    DMINUS: 141,
    DMINUSNEGATIVE: 142,
};
export var shallowRatingWeightage = {
    AAAPLUS: 1,
    AAA: 2,
    AAAMINUS: 3,
    AAPLUS: 4,
    AA: 5,
    AAMINUS: 6,
    APLUS: 7,
    A: 8,
    AMINUS: 9,
    BBBPLUS: 10,
    BBB: 10,
    BBBMMINUS: 11,
    BBPLUS: 12,
    BB: 13,
    BBMINUS: 14,
    BPLUS: 15,
    B: 16,
    BMINUS: 17,
    CCCPLUS: 18,
    CCC: 19,
    CCCMINUS: 20,
    CCPLUS: 21,
    CC: 22,
    CCMINUS: 23,
    CPLUS: 24,
    C: 25,
    CMINUS: 26,
    DDDPLUS: 27,
    DDD: 28,
    DDDMINUS: 29,
    DDPLUS: 30,
    DD: 31,
    DDMINUS: 32,
    DPLUS: 33,
    D: 34,
    DMINUS: 35,
};
export var getScore = function (rating) {
    var RatingKey = rating
        .replace("(", "")
        .replace(")", "")
        .replace("+", "PLUS")
        .replace("-", "MINUS");
    return RatingKey;
};
export var getHighestRating = function (ratings) {
    var HighestRating = "D-/negative";
    var HighestRatingKey = "DMINUSNEGATIVE";
    if (!ratings) {
        return HighestRatingKey;
    }
    // let RatingList = ratings.split(",");
    // RatingList.map((rating: string) => {
    var RatingScore = ratings.split("=>")[1];
    var ratingKey = getScore(RatingScore);
    // if (ratingWeightage[ratingKey as keyof typeof ratingWeightage] < ratingWeightage[HighestRatingKey as keyof typeof ratingWeightage]) {
    //   HighestRating = RatingScore;
    //   HighestRatingKey = ratingKey;
    // }
    // })
    return ratingKey;
};
export var getShallowHighestRating = function (ratings) {
    var HighestRating = "D-";
    var HighestRatingKey = "DMINUS";
    if (!ratings) {
        return HighestRatingKey;
    }
    var RatingScore = ratings.split("=>")[1];
    var ratingKey = RatingScore.split("(")[0];
    return ratingKey;
};
export function ratingSort(data, sortKey, sortOrder) {
    var _a;
    return (_a = __spreadArray([], __read(data), false)) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
        var weightingA = ratingWeightage[getHighestRating(a[sortKey]).toUpperCase()];
        var weightingB = ratingWeightage[getHighestRating(b[sortKey]).toUpperCase()];
        var shallowWeightingA = shallowRatingWeightage[getShallowHighestRating(a[sortKey]).toUpperCase()];
        var shallowWeightingB = shallowRatingWeightage[getShallowHighestRating(b[sortKey]).toUpperCase()];
        if (weightingA && weightingB) {
            if (weightingA < weightingB) {
                return 1 * sortOrder;
            }
            if (weightingA > weightingB) {
                return -1 * sortOrder;
            }
        }
        else if (shallowWeightingA && shallowWeightingB) {
            if (shallowWeightingA < shallowWeightingB) {
                return 1 * sortOrder;
            }
            if (weightingA > weightingB) {
                return -1 * sortOrder;
            }
        }
        else if (weightingA) {
            return 1 * sortOrder;
        }
        else if (weightingB) {
            return -1 * sortOrder;
        }
        return -1 * sortOrder;
    });
}
export function dateSorting(data, sortKey, sortOrder) {
    var _a;
    return (_a = __spreadArray([], __read(data), false)) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
        if (moment(sortKey ? a[sortKey] : a).diff(moment(sortKey ? b[sortKey] : b), //handle for array and object
        "days") < 0) {
            return 1 * sortOrder;
        }
        if (moment(sortKey ? a[sortKey] : a).diff(moment(sortKey ? b[sortKey] : b), //handle for array and object
        "days") > 0) {
            return -1 * sortOrder;
        }
        return 0;
    });
}
export function dateSort(data, sortKey, sortOrder) {
    var _a, _b;
    switch (sortOrder) {
        case ESortOrder.ASC:
            return (_a = __spreadArray([], __read(data), false)) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
                var dateA = moment(a[sortKey]);
                var dateB = moment(b[sortKey]);
                if (!dateA.isValid() && !dateB.isValid()) {
                    return 0;
                }
                if (!dateA.isValid()) {
                    return 1;
                }
                if (!dateB.isValid()) {
                    return -1;
                }
                // Compare valid dates
                return dateA.diff(dateB);
            });
        case ESortOrder.DESC:
            return (_b = __spreadArray([], __read(data), false)) === null || _b === void 0 ? void 0 : _b.sort(function (a, b) {
                var dateA = moment(a[sortKey]);
                var dateB = moment(b[sortKey]);
                if (!dateA.isValid() && !dateB.isValid()) {
                    return 0; // Both are invalid, consider them equal
                }
                if (!dateA.isValid()) {
                    return 1; // Push invalid date A to the end
                }
                if (!dateB.isValid()) {
                    return -1; // Push invalid date B to the end
                }
                // Compare valid dates
                return dateB.diff(dateA);
            });
        default:
            return data;
    }
}
export function stringSort_depricated(data, sortKey, sortOrder) {
    var _a;
    return (_a = __spreadArray([], __read(data), false)) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
        if (a[sortKey] === null) {
            return 1;
        }
        if (b[sortKey] === null) {
            return -1;
        }
        if (a[sortKey] === "") {
            return 1;
        }
        if (b[sortKey] === "") {
            return -1;
        }
        if (a[sortKey] < b[sortKey]) {
            return 1 * sortOrder;
        }
        if (a[sortKey] > b[sortKey]) {
            return -1 * sortOrder;
        }
        return 0;
    });
}
export function stringSort(data, sortKey, sortOrder) {
    var _a;
    return (_a = __spreadArray([], __read(data), false)) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
        if (a[sortKey] < b[sortKey]) {
            return -1 * sortOrder;
        }
        if (a[sortKey] > b[sortKey]) {
            return 1 * sortOrder;
        }
        return 0;
    });
}
export var sortData = function (sortStateData, filterData) {
    if (sortStateData.type === "string") {
        return stringSort_depricated(filterData, sortStateData.key, sortStateData.order);
    }
    else if (sortStateData.type === "Date")
        return dateSort(filterData, sortStateData.key, sortStateData.order);
    else {
        return sort(filterData, sortStateData.key, sortStateData.order);
    }
};
export default function sort(data, sortKey, sortOrder) {
    var _a;
    return (_a = __spreadArray([], __read(data), false)) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
        var left;
        var right;
        if (isNaN(+a[sortKey])) {
            left = 0;
        }
        else {
            left = +a[sortKey];
        }
        if (isNaN(+b[sortKey])) {
            right = 0;
        }
        else {
            right = +b[sortKey];
        }
        if (left < right) {
            return -1 * sortOrder;
        }
        if (left > right) {
            return 1 * sortOrder;
        }
        return 0;
    });
}
export var getSortedData = function (data, type, key, dataType) {
    var sortType = type ? ESortOrder.ASC : ESortOrder.DESC;
    if (dataType === "string") {
        return stringSort(data, key, sortType);
    }
    else if (dataType === "Date")
        return dateSort(data, key, sortType);
    else if (dataType === "Rating")
        return ratingSort(data, key, sortType);
    else if (dataType === "numberWithComma")
        return sort(data.map(function (x) {
            var _a;
            if (x[key] === "-" ||
                x[key] === "" ||
                x[key] === null ||
                x[key] === undefined)
                return x;
            return __assign(__assign({}, x), (_a = {}, _a[key] = parseFloat(x[key].replace(/,/g, "")), _a));
        }), key, sortType).map(function (x) {
            var _a;
            return __assign(__assign({}, x), (_a = {}, _a[key] = addCommas(x[key]), _a));
        });
    // else if (dataType === "Date") {
    //   return data.sort((a, b) => {
    //     return moment(b).toDate() - moment(a).toDate();
    //   });
    // }
    else {
        return sort(data, key, sortType);
    }
};
